/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />

module App.Controllers {
    export interface IAppointmentSavedController extends IBaseController {

    }

    export class AppointmentSavedController extends BaseController implements IAppointmentSavedController {
        static controllerId = 'appointmentSavedController';

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            '$stateParams',
            '$sce',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            'ngDialog',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId,
            SnackbarFactory.factoryId
        ];

        thankyoutxt: string;
        websiteUrl: string;
        brandName: string;
        phoneNumber: string;

        constructor($rootScope: Interfaces.IAppRootScope, $scope: ng.IScope,
            $q: ng.IQService,
            $stateParams: ng.ui.IStateParamsService,
            $sce: ng.ISCEService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            composition: Interfaces.ICompositionService,
            ngDialog: any, 
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService,
            snackbarFactory: Interfaces.ISnackbarFactory) {
            super($rootScope, $scope, $q, sessionService, navigationService, composition, ngDialog, $sce, validationService, accountService, snackbarFactory);

            this.phoneNumber = App.Variables.telephone;
            this.thankyoutxt = $sce.trustAsHtml(Variables.thankyoutxt);
            this.websiteUrl = App.Variables.websiteUrl;
            this.brandName = App.Variables.brandName;
        }
    }

    app.controller(AppointmentSavedController.controllerId, AppointmentSavedController);
}